import { CaseOCSConsoleResource, CaseResource, CaseResourceCombined, CaseResourceType } from '@/api/apis/case';
import { queryClient } from '@/queries';
import { resourceAvailabilityQueries } from '@/queries/resource/availability';
import { hubQueries } from '@/queries/hub';
import { ocsConsoleQueries } from '@/queries/ocs-consoles';

export const getResourcesCombined = async (resources: CaseResourceCombined[]) => {
  return Promise.all(
    resources.map(async (r) => {
      if (
        [CaseResourceType.Employee, CaseResourceType.ClinicalSpecialist, CaseResourceType.Surgeon].includes(
          r.resourceType,
        )
      ) {
        const data = await queryClient.ensureQueryData(
          resourceAvailabilityQueries.employeeById({ employeeId: r.resourceId }),
        );

        return {
          ...r,
          data,
        } as CaseResource;
      }

      if (r.resourceType === 'OCSConsole') {
        const data = await queryClient.ensureQueryData(ocsConsoleQueries.item(r.resourceId, { withDeleted: true }));
        const hub = await queryClient.ensureQueryData(hubQueries.item(data.nopHub));

        return {
          ...r,
          data: {
            ...data,
            hub,
          },
        } as CaseResource<CaseOCSConsoleResource>;
      }

      return r;
    }),
  );
};
